<ng-container *ngIf="consumableReport.length || dprConsumable.comment">
  <!--Consumable without stock-->
  <table *ngIf="!subprojectConfiguration.enableStockForConsumables" class="layout-fixed striped">
    <colgroup>
      <col class="width-25" />
      <col class="width-5" />
      <col class="width-10" />
      <col class="width-10" />
      <col class="width-10" />
      <col class="width-40" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="6">
          <h3>{{subprojectConfiguration.customNames.consumablesTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="consumableReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{consumableColName}}</td>
          <td>{{unitsColName}}</td>
          <td class="text-center">{{StaticMessage.PreviousColumn | staticMessage}}</td>
          <td class="text-center">{{StaticMessage.TodayColumn | staticMessage}}</td>
          <td class="text-center">{{StaticMessage.TotalColumn | staticMessage}}</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let consumable of consumableReport">
        <td class="accent">{{consumable.name}}</td>
        <td class="accent">{{consumable.units}}</td>
        <td class="text-center">{{consumable.previous}}</td>
        <td class="text-center">{{consumable.today}}</td>
        <td class="text-center">{{consumable.total}}</td>
        <td>{{consumable.comment | trim}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprConsumable.comment">
      <tr>
        <td colspan="6">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprConsumable.comment">
      <tr>
        <td colspan="6" class="white-space-pre-wrap" [innerHTML]="(dprConsumable.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>

  <!--Consumable with stock-->
  <table *ngIf="subprojectConfiguration.enableStockForConsumables" class="layout-fixed striped">
    <colgroup>
      <col style="width: 20%" />
      <col style="width: 5%" />
      <col style="width: 11%" />
      <col style="width: 7%" />
      <col style="width: 7%" />
      <col style="width: 11%" />
      <col style="width: 14%" />
      <col style="width: 25%" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="8">
          <h3>{{subprojectConfiguration.customNames.consumablesTabName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="consumableReport.length">
      <tbody class="secondary-header">
        <tr>
          <td>{{consumableColName}}</td>
          <td>{{unitsColName}}</td>
          <td class="text-center" i18n="@@report.reportConsumables.colTotalStartOfDay">Total aboard start of day</td>
          <td class="text-center" i18n="@@report.reportConsumables.colAdded">Added</td>
          <td class="text-center" i18n="@@report.reportConsumables.colUsed">Used</td>
          <td class="text-center" i18n="@@report.reportConsumables.colTotalEndOfDay">Total aboard end of day</td>
          <td class="text-center" i18n="@@report.reportConsumables.colTotalUsed">Total used</td>
          <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let consumable of consumableReport">
        <td class="accent">{{consumable.name}}</td>
        <td class="accent">{{consumable.units}}</td>
        <td class="text-center">{{consumable.dailyStockDetails.totalStartOfDay | number: '1.2-2'}}</td>
        <td class="text-center">{{consumable.added}}</td>
        <td class="text-center">{{consumable.used}}</td>
        <td class="text-center">{{consumable.dailyStockDetails.totalEndOfDay | number: '1.2-2'}}</td>
        <td class="text-center">{{consumable.dailyStockDetails.totalUsed | number: '1.2-2'}}</td>
        <td>{{(consumable.comment | trim) || '-'}}</td>
      </tr>
    </tbody>
    <tbody class="secondary-header" *ngIf="dprConsumable.comment">
      <tr>
        <td colspan="8">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
      </tr>
    </tbody>
    <tbody *ngIf="dprConsumable.comment">
      <tr>
        <td colspan="8" class="white-space-pre-wrap" [innerHTML]="(dprConsumable.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>
</ng-container>
